import { ProfileFields } from "@/components/profile/ProfileFields";
/**
 * Sprint S13.1.B.2 — Step 7: primary_goals (controlled vocab + free-text).
 */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/Button";
import { useOnboardingStore } from "@/stores/onboardingStore";
import { FieldMultiSelect } from "@/components/onboarding/fields/FieldMultiSelect";


const GOAL_OPTIONS = [
  "complete_ironman_70_3_oct_2026",
  "complete_ironman_full",
  "marathon_sub_4",
  "marathon_sub_3_30",
  "general_fitness",
  "weight_management",
  "injury_recovery",
  "race_specific_training",
  "performance_plateau",
];


export function Step7Goals() {
  const { t } = useTranslation();
  const data = useOnboardingStore((s) => s.data);
  const setData = useOnboardingStore((s) => s.setData);
  const setField = useOnboardingStore((s) => s.setField);
  const nextStep = useOnboardingStore((s) => s.nextStep);

  const initialOther = data.primary_goals
    .filter((v) => v.startsWith("other:"))
    .map((v) => v.slice(6))
    .join(", ");
  const [otherGoal, setOtherGoal] = useState(initialOther);

  const goalOptions = GOAL_OPTIONS.map((v) => ({
    value: v,
    label: t(`onboarding.step.goals.goal.${v}`),
  }));

  const controlledGoals = data.primary_goals.filter(
    (v) => !v.startsWith("other:"),
  );

  const handleNext = () => {
    const goals = [...controlledGoals];
    if (otherGoal.trim()) goals.push(`other:${otherGoal.trim()}`);
    setField("primary_goals", goals);
    nextStep();
  };

  return (
    <form onSubmit={(event) => { event.preventDefault(); handleNext(); }} className="space-y-6">
      <div>
        <h2
          id="step-heading"
          tabIndex={-1}
          className="mb-2 text-xl font-semibold text-navy-deep sm:text-2xl"
        >
          {t("onboarding.step.goals.title")}
        </h2>
        <p className="text-[13px] text-taupe sm:text-[14px]">
          {t("onboarding.step.goals.subtitle")}
        </p>
        <p className="mt-1 text-[12px] text-taupe-light">
          {t("onboarding.step.goals.hint")}
        </p>
      </div>

      <FieldMultiSelect
        label={t("onboarding.step.goals.goals_label")}
        hint={t("onboarding.step.goals.goals_hint")}
        options={goalOptions}
        selected={controlledGoals}
        onChange={(values) => setField("primary_goals", values)}
        allowOther
        otherValue={otherGoal}
        onOtherChange={setOtherGoal}
        otherPlaceholder={t("onboarding.step.goals.other_placeholder")}
      />

      <ProfileFields section="nutrition" data={data} onChange={setData} />

      <div className="pt-2">
        <Button
          type="submit"
          data-onboarding-next
          className="w-full sm:w-auto"
        >
          {t("onboarding.nav.next")}
        </Button>
      </div>
    </form>
  );
}
